// TODO: change this to module css
import "./availability.scss";

import { DayOfWeek, RecurrencePattern } from "./availability.types";
import React, { useCallback, useEffect, useState } from "react";
import {
  addDays,
  addMonths,
  endOfMonth,
  endOfWeek,
  format,
  formatISO,
  isSameDay,
  isSameMonth,
  isToday,
  startOfMonth,
  startOfWeek,
  subMonths,
} from "date-fns";
import {
  convertIndexToSession,
  formatDateToLong,
  generateEndTimeSlots,
  generateTimeSlots,
  getWeekdayTimeSlots,
  handleISOFormat,
  handleISOFormatTimeOnly,
} from "../../utils/helpers";
import { days, dummySession } from "./days";
import {
  deleteSlots,
  getSchedules,
  recurring,
  timeSlot,
  updateTimeSlots,
} from "../../features/Availability";
import {
  fetchCompletedLessons,
  fetchIncompleteLessons,
} from "../../features/Availability";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import AlertMessage from "../lessons/trial/AlertMessage";
import { AppLoader } from "../../components/AppLoader";
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ILesson } from "../../types/schedule";
import Icon from "../../components/Icon";
import Layout from "../layout/Portal";
import { SelectDays } from "./select-days";
import SelectTime from "./TimeSelect/SelectTime";
import Switch from "react-switch";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faCalendarXmark } from "@fortawesome/free-regular-svg-icons";
import { sortLessons } from "../../utils/helpers";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useRole } from "../../context/RoleContext";
import { useTrialLesson } from "../../context/TrailLessonContext";

export interface timeslots {
  id: string | null;
  start: string;
  end: string;
}
export interface RecurringTimeSlotDto {
  timeSlots: { start: string; end: string }[];
  pattern: RecurrencePattern;
  daysOfWeek: DayOfWeek[];
  startDate: string; // First date of recurrence
  endDate: string; // Last date of recurrence
}
export const Availability = () => {
  const { isTrialLessonCreated } = useTrialLesson();
  const { role } = useRole();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [checked, setChecked] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(
    new Date().toLocaleDateString(),
  );
  // const [startTime, setStartTime] = useState<any>("");
  // const [selectedTimeSlot, setSelectedTimeSlot] = useState<any>([]);
  const [startEndTime, setStartEndTime] = useState<any>([
    { id: null, end: "", start: "" },
  ]);
  const [filteredBookedSession, setFilteredBookedSession] = useState<any>();
  const [editId, setEditId] = useState<string | null>(null);
  const [lastTime, setLastTime] = useState("");
  const [delModal, setDelModal] = useState(false);
  const [timeSlotId, setTimeSlotId] = useState<timeslots>();
  const [discard, setDiscard] = useState<boolean>(false);
  const [recurr, setReccur] = useState<RecurringTimeSlotDto>({
    timeSlots: [],
    pattern: "weekly",
    daysOfWeek: [],
    startDate: "",
    endDate: "",
  });

  const handleChange = (checked: boolean) => {
    setSelectedDate(
      checked
        ? new Date(
            new Date().setDate(new Date().getDate() + 1),
          ).toLocaleDateString()
        : new Date().toLocaleDateString(),
    );
    setChecked(checked);
  };

  const prevMonth = () => {
    setCurrentDate(subMonths(currentDate, 1));
  };

  const nextMonth = () => {
    setCurrentDate(addMonths(currentDate, 1));
  };

  const startDate = startOfWeek(startOfMonth(currentDate));
  const endDate = endOfWeek(endOfMonth(currentDate));

  const generateCalendar = () => {
    let day = startDate;
    const days = [];

    while (day <= endDate) {
      days.push(day);
      day = addDays(day, 1);
    }
    return days;
  };

  const calendarDays = generateCalendar();

  const dateHandler = (day: any, prev: any) => {};
  const [timeStartHandler, updateTimeStartHandler] = useState<any>([]);
  const [timeEndHandler, updateTimeEndHandler] = useState<any>([]);
  const [daySelect, updateDaySelect] = useState<any>("");
  const [timeFrame, updateTimeFrame] = useState<any>({
    from: "",
    to: "",
  });
  const [pickedDates, updatePickedDates] = useState<any>([]);
  const [isValid, setIsValid] = useState(false);

  const _timeStartAppend = () => {
    const lastEndTime =
      startEndTime.length > 0
        ? startEndTime[startEndTime.length - 1].end
        : null;
    setLastTime(lastEndTime);

    const filteredStartTimes = generateTimeSlots(
      selectedDate,
      startEndTime,
    ).filter((slot: string) => {
      return !startEndTime.some(
        (timeSlot: any) =>
          timeSlot.start === slot || (lastTime && slot < lastTime),
      );
    });

    if (lastTime && !filteredStartTimes.includes(lastTime)) {
      filteredStartTimes.push(lastTime);
    }

    updateTimeStartHandler(filteredStartTimes);
    return filteredStartTimes;
  };

  const _timeEndAppend = () => {
    if (
      startEndTime.length > 0 &&
      startEndTime[startEndTime.length - 1].start
    ) {
      const currentStart = startEndTime[startEndTime.length - 1].start;

      const filteredEndTimes = generateEndTimeSlots(currentStart).filter(
        (slot: string) => {
          return !startEndTime.some((timeSlot: any) => {
            const start = timeSlot.start;
            const end = timeSlot.end;

            return (start <= slot && slot <= end) || slot <= currentStart;
          });
        },
      );

      updateTimeEndHandler(filteredEndTimes);
    }
  };

  useEffect(() => {
    if (startEndTime) {
      _timeStartAppend();
      _timeEndAppend();
    }
  }, [selectedDate, startEndTime]);

  useEffect(() => {
    _timeEndAppend();
  }, [startEndTime]);

  const checkdayTime = (value: any) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return value < today;
  };

  const compareDate = (value: any) => {
    const today = new Date(timeFrame.from);
    today.setHours(0, 0, 0, 0);
    return value < today;
  };

  const { data: _completed_lessons, isLoading: completedLoading } = useQuery({
    queryKey: ["merchant_schedule_completed"],
    queryFn: fetchCompletedLessons,
  });

  const { data: _upcoming_lessons, isLoading: upcomingLoading } = useQuery({
    queryKey: ["merchant_schedule_upcoming"],
    queryFn: fetchIncompleteLessons,
  });

  const renderCalendar = () => {
    return calendarDays.map((day, index) => {
      const isHighlighted = pickedDates?.filter((highlightedDate: any) => {
        return isSameDay(
          day.toLocaleDateString(),
          new Date(highlightedDate?.time?.start),
        );
      });

      return (
        <div
          key={index}
          className={`day ${isSameMonth(day, selectedDate) ? "" : "disabled"} 
          ${isSameDay(day, selectedDate) ? "today" : "notToday"}
          `}
          onClick={() => {
            if (checkdayTime(day)) {
              toast.warning(
                " You can not select a past date, Please select a later date",
                {
                  richColors: true,
                },
              );
              const newDate = new Date(
                new Date().setDate(new Date().getDate() + 1),
              ).toLocaleDateString();

              // setSelectedDate(checked ? newDate : new Date().toLocaleDateString());
            } else {
              setSelectedDate((prev: any) => {
                if (prev !== day.toLocaleDateString()) {
                  setStartEndTime([{ id: null, end: "", start: "" }]);
                }
                return day.toLocaleDateString();
              });
            }
          }}
        >
          <span
            className={
              isSameDay(day, selectedDate) ? "day-number-picked" : "day-number"
            }
          >
            {format(day, "EEE")}
          </span>
          <span
            className={
              isSameDay(day, selectedDate) ? "day-number-picked" : "day-number"
            }
          >
            {format(day, "d")}
          </span>
          {isHighlighted?.length > 0 ? (
            <div
              className={
                isSameDay(day, selectedDate) ? "day-text-picked" : "day-text"
              }
            >
              {isHighlighted && `${isHighlighted.length} session(s)`}
            </div>
          ) : null}
        </div>
      );
    });
  };

  const _deleteHandler = (index: any) => {
    if (index < 1) return;
    if (index !== null) {
      deleteTimeSlots(index);
    }
  };

  const handleSelect = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number,
  ) => {
    const { name, value } = e.target;

    setEditId(startEndTime[index]?.id !== null ? startEndTime[index].id : null);
    setStartEndTime((prevValues: any) =>
      prevValues.map(
        (item: any, i: number) =>
          i === index
            ? {
                ...item,
                id:
                  startEndTime[index]?.id !== null
                    ? startEndTime[index].id
                    : null,
                start: name === "start" ? value : item.start,
                end: name === "end" ? value : item.end,
              }
            : item,
        // i > index
        // ? { end: "", start: "", id: null } // Clear subsequent objects
        // :
      ),
    );
  };

  useEffect(() => {
    setReccur((prev: any) => ({
      ...prev,
      timeSlots: startEndTime
        ?.filter(
          (item: timeslots) =>
            item.id === null && (item.start !== "" || item.end !== ""),
        )
        .map((item: any) => ({
          start: handleISOFormatTimeOnly(
            `${item?.start?.split(":")[0].padStart(2, "0")}:${item?.start
              ?.split(":")[1]
              ?.padStart(2, "0")}`,
            timeFrame?.from ? new Date(timeFrame.from) : new Date()
          ),
          end: handleISOFormatTimeOnly(
            `${item?.end?.split(":")[0]?.padStart(2, "0")}:${item?.end
              ?.split(":")[1]
              ?.padStart(2, "0")}`,
            timeFrame?.to ? new Date(timeFrame.to) : new Date()
          ),
        })),
      pattern: "weekly",
      daysOfWeek: daySelect,
      startDate: timeFrame?.from ? new Date(timeFrame?.from).toISOString() : "",
      endDate: timeFrame?.to ? new Date(timeFrame?.to).toISOString() : "",
    }));
  }, [daySelect, timeFrame, startEndTime]);

  useEffect(() => {
    setReccur((prev) => ({
      ...prev,
      startDate: timeFrame?.from ? new Date(timeFrame?.from).toISOString() : "",
      endDate: timeFrame?.to ? new Date(timeFrame?.to).toISOString() : "",
    }));
  }, [timeFrame]);

  useEffect(() => {
    setIsValid(
      startEndTime.some((item: any) => {
        if (item.start === "" || item.end === "") return true;
      }),
    );
  }, [startEndTime]);

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // 24-hour
    timeZone: userTimezone, // UTC+1 zone (handles DST)
  };

  const handleAvailability = async () => {
    if (isValid) {
      setStartEndTime((prev: any) =>
        prev.filter((item: any) => item.start !== "" && item.end !== ""),
      );
    }

    if (startEndTime[0].start === "" || startEndTime[0].end === "") {
      alert("Please select a time slot");
    } else {
      if (daySelect === "") {
        if (editId === null) {
          let dateTime = startEndTime
            ?.filter(
              (item: timeslots) =>
                item.id === null && (item.start !== "" || item.end !== ""),
            )
            .map((item: timeslots) => ({
              start: handleISOFormat(item.start, selectedDate),
              end: handleISOFormat(item.end, selectedDate),
            }));
          if (dateTime.length === 0) {
            return toast.warning("please select a timeslot", {
              richColors: true,
            });
          }

          try {
            await submitTimeslot({
              role: role,
              timeSlots: dateTime,
            });
          } catch (error) {
            console.error(error);
          }
        } else {
        }
      } else {
        try {
          await submitRecurringTimeslot({ role: role, recurring: recurr });
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  useEffect(() => {
    if (
      startEndTime?.length > 1 &&
      startEndTime.start !== "" &&
      startEndTime.end !== ""
    ) {
      let isNewEntry = startEndTime.some(
        (item: timeslots) => item.id === "null",
      );

      isNewEntry && setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, []);

  const { mutateAsync: submitTimeslot, isPending } = useMutation({
    mutationFn: timeSlot,
    onSuccess: () => {
      toast.success("Time slots successfully created", {
        richColors: true,
      });
      queryClient.invalidateQueries({ queryKey: ["schedules"] });
    },
    onError: (error) => {
      toast.error(error?.message || "something went wrong", {
        richColors: true,
      });
    },
  });
  const {
    mutateAsync: submitRecurringTimeslot,
    isPending: isPendingRecurring,
  } = useMutation({
    mutationFn: recurring,
    onSuccess: () => {
      toast.success("Recurring time slots successfully created", {
        richColors: true,
      });
    },
    onError: (error) => {
      toast.error(error?.message || "Error. please try again", {
        richColors: true,
      });
    },
  });

  const { mutateAsync: deleteTimeSlots, isPending: isDeleting } = useMutation({
    mutationFn: deleteSlots,
    onSuccess: () => {
      setDelModal(false);
      toast.success("Time Slot successfully deleted", {
        richColors: true,
      });
      queryClient.invalidateQueries({ queryKey: ["schedules"] });
    },
    onError: () => {
      toast.error("failed to delete. Please try again", {
        richColors: true,
      });
    },
  });

  const updateHandler = async (id: number) => {
    let value = startEndTime[id];
    try {
      await updateSlots({
        id: value?.id,
        start: handleISOFormat(value?.start, selectedDate) || "",
        end: handleISOFormat(value?.end, selectedDate) || "",
      });
    } catch (error) {
      console.error(error);
    }
  };

  const { mutateAsync: updateSlots, isPending: updatePending } = useMutation({
    mutationFn: updateTimeSlots,
    onSuccess: (data) => {
      if (data?.status === 200) {
        setEditId(null);
      }
      toast.success("Time slot edited successfully ", {
        richColors: true,
      });
    },
    onError: (error: any) => {
      toast.error(error || "Something went wrong", {
        richColors: true,
      });
    },
  });
  useEffect(() => {
    const allbookings: ILesson[] = [
      ...(_completed_lessons ?? []),
      ...(_upcoming_lessons ?? []),
    ];
    updatePickedDates((allbookings ?? []).sort(sortLessons));
  }, [_completed_lessons, _upcoming_lessons]);

  useEffect(() => {
    setFilteredBookedSession(
      pickedDates.filter((picked: ILesson) => {
        return (
          new Date(picked?.time?.start).toLocaleDateString() === selectedDate
        );
      }),
    );
  }, [pickedDates, selectedDate]);

  // useEffect(() => {
  //   if (availableTimes) {
  //     setStartEndTime(() => {
  //       const today = new Date(selectedDate);

  //       let availableToday = availableTimes?.result.filter((item: any) => {
  //         if (new Date(item?.start).toLocaleDateString() === today.toLocaleDateString()) {
  //           return true;
  //         } else return false;
  //       });

  //       if (availableToday.length === 0) {
  //         return [{ id: null, end: "", start: "" }];
  //       } else {
  //         const formattedTimes = availableToday?.map((data: any) => ({
  //           id: data?.id,
  //           start: `${new Date(data?.start).getHours()}:${new Date(data?.start)
  //             .getMinutes()
  //             .toString()
  //             .padStart(2, "0")}`,
  //           end: `${new Date(data?.end).getHours()}:${new Date(data?.end)
  //             .getMinutes()
  //             .toString()
  //             .padStart(2, "0")}`,
  //         }));

  //         return formattedTimes;
  //       }
  //     });
  //   }
  // }, [availableTimes, selectedDate]);

  const handleSelectionChange = (selectedDays: Set<DayOfWeek>): void => {
    if (selectedDays.size === 0) {
      updateDaySelect("");
      return;
    }
    updateDaySelect(Array.from(selectedDays));
  };

  return (
    <Layout>
      <div className="" style={{ marginBottom: "2rem" }}>
        {!isTrialLessonCreated && <AlertMessage title="Action Required" />}
      </div>
      <div className="wrapped">
        {delModal && (
          <>
            <div className="overlaySection"></div>
            <div className="delModal">
              <h1>Are you sure?</h1>
              <p>Do you want to delete this timeslots between </p>
              <p className="frmes">
                {timeSlotId?.start} and {timeSlotId?.end}{" "}
              </p>
              <div className="delButtons">
                <button onClick={() => setDelModal(false)}>Cancel</button>
                <button
                  onClick={() => _deleteHandler(timeSlotId?.id)}
                  className="delConfirm"
                  disabled={isDeleting}
                >
                  {isDeleting && <ClipLoader size={20} color="white" />}
                  Delete
                </button>
              </div>
            </div>
          </>
        )}
        <div className="calendar-container">
          <div className="calendar-header">
            <button onClick={prevMonth} className="month-nav">
              <FontAwesomeIcon
                icon={["fas", "chevron-left"]}
                className="sideIcon"
              />
            </button>
            <h6 className="month">{format(currentDate, "MMMM")}</h6>
            <h6 className="year">{format(currentDate, "yyyy")}</h6>
            <button onClick={nextMonth} className="month-nav">
              <FontAwesomeIcon
                className="sideIcon"
                icon={["fas", "chevron-right"]}
              />
            </button>
          </div>

          <div className="weekDay">
            <div className="calendar-grid">{renderCalendar()}</div>
          </div>
        </div>

        <div className="bottomContainer">
          <div className="leftContainer">
            <p className="session">Booked Sessions</p>
            {completedLoading || upcomingLoading ? (
              <AppLoader />
            ) : filteredBookedSession?.length > 0 ? (
              <div className="sessionContainer">
                {filteredBookedSession.map((item: any, index: any) => {
                  return (
                    <div key={index} className="sessionBox">
                      <div className="titleBox">
                        <p key={index} className="mapped">
                          {convertIndexToSession(index)}
                        </p>
                      </div>
                      <div className="iconSessions">
                        <div className="sessionData">
                          <p key={index} className="sessionTitle">
                            {item?.content?.lessonTitle}
                          </p>

                          <p className="mappedSession">{`${new Date(
                            item?.time?.start,
                          ).toLocaleTimeString()} - ${new Date(
                            item?.time?.end,
                          ).toLocaleTimeString()}`}</p>
                          <div
                            className={`${
                              item?.completed ? "statComplete" : "upcoming"
                            } statBox`}
                          >
                            <p>{item?.completed ? "completed" : "upcoming"}</p>
                          </div>
                        </div>
                        <div
                          className="iconsBox"
                          onClick={() => navigate(`/schedule/${item?.id}`)}
                        >
                          <FontAwesomeIcon
                            className="icons"
                            icon={faArrowUpRightFromSquare}
                          />
                        </div>
                      </div>
                    </div>
                  );
                  // } else {
                  //   <div className="nullBooking">
                  //     <FontAwesomeIcon className="icon" icon={faCalendarXmark} />
                  //     <p>You do not have any booked session</p>
                  //   </div>;
                  // }
                })}
              </div>
            ) : (
              <div className="nullBooking">
                <FontAwesomeIcon className="icons" icon={faCalendarXmark} />
                <p>You do not have any booked session</p>
              </div>
            )}
          </div>
          <div className="rightContainer">
            <div className="switchCon">
              {/* TODO: Setting today how does it work does it have a spinner while doing it, can you toggle it back on */}
              <Switch
                offColor={"#E1E8ED"}
                checkedIcon={false}
                uncheckedIcon={false}
                onChange={handleChange}
                checked={checked}
                height={26}
              />
              <p className="unavailable">Set today as Unavailable</p>
            </div>
            <div className="setAval">
              <SelectTime
                setTimes={setStartEndTime}
                startEnd={startEndTime}
                updateModal={setDelModal}
                id={editId}
                setid={setEditId}
                setTimeId={setTimeSlotId}
                updateSlot={updateHandler}
                pending={updatePending}
                pickedDay={selectedDate}
              />
              <div className="outterBtnContainer"></div>
            </div>
            <div className="line" />

            <div className="reccur">
              <label>Repeat</label>
              <SelectDays
                onSelectionChange={handleSelectionChange}
                discard={discard}
                setDiscard={setDiscard}
              />
            </div>

            {daySelect ? (
              <div className="input2">
                <div className="from-to">
                  <label>Time Frame (From)</label>
                  <input
                    onChange={(e) => {
                      if (checkdayTime(new Date(e.target.value))) {
                        toast.warning(
                          " You can not select a past date, Please select a later date",
                          {
                            richColors: true,
                          },
                        );
                        updateTimeFrame({
                          ...timeFrame,
                          from: "",
                        });
                      } else {
                        updateTimeFrame({
                          ...timeFrame,
                          from: e.target.value,
                        });
                      }
                    }}
                    name="startDate"
                    className="selectInput"
                    type="date"
                    value={timeFrame.from}
                  />
                </div>

                <div className="from-to">
                  <label>Time Frame (To)</label>
                  <input
                    onChange={(e) => {
                      if (compareDate(new Date(e.target.value))) {
                        // alert(" You can not select a date, That goes beyond from that");
                        updateTimeFrame({
                          ...timeFrame,
                          to: "",
                        });
                      } else {
                        updateTimeFrame({
                          ...timeFrame,
                          to: e.target.value,
                        });
                      }
                    }}
                    name="endDate"
                    className="selectInput"
                    type="date"
                    value={timeFrame.to}
                  />
                </div>
              </div>
            ) : null}
            <div className="buttons">
              <button
                onClick={() => {
                  setDiscard(true);
                  updateDaySelect("");
                  updateTimeFrame({
                    from: "",
                    to: "",
                  });
                }}
                type="reset"
                className="discardBtn"
              >
                Discard
              </button>
              <button
                onClick={handleAvailability}
                className={` ${isValid ? "dizable" : "saveBtn"}`}
                disabled={isValid}
              >
                {(isPending || isPendingRecurring) && (
                  <ClipLoader size={20} color="#1491d8" />
                )}
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
